import { Route, Switch } from "react-router-dom";
import ReceberListagemPage from "./Listagem";

function ReceberPages() {
  return (
    <Switch>
      <Route
        exact
        path="/financeiro/receita/receber"
        component={ReceberListagemPage}
      />
    </Switch>
  );
}

export default ReceberPages;
